// extracted by mini-css-extract-plugin
module.exports = {"root":"Award_root__LqWUE","icon":"Award_icon__xy58d","title":"Award_title__GOci5","subtitle":"Award_subtitle__4lLqu"};